import React, { useState } from 'react';
import { Upload, Image as ImageIcon, Download, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const MyImages = () => {
  const [images, setImages] = useState([
    {
      id: '1',
      url: 'https://images.unsplash.com/photo-1618519764620-7403abdbdfe9?w=400&h=400&fit=crop',
      name: 'Generated Art 1',
      createdAt: '2024-01-15',
    },
    {
      id: '2',
      url: 'https://images.unsplash.com/photo-1547891654-e66ed7ebb968?w=400&h=400&fit=crop',
      name: 'AI Portrait',
      createdAt: '2024-01-14',
    },
    {
      id: '3',
      url: 'https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?w=400&h=400&fit=crop',
      name: 'Space Landscape',
      createdAt: '2024-01-13',
    },
  ]);

  const handleDelete = (id) => {
    setImages(images.filter((img) => img.id !== id));
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">My Images</h1>
          <p className="text-gray-400">Manage your AI-generated images</p>
        </div>
        <Button className="bg-purple-600 hover:bg-purple-700 text-white">
          <Upload size={18} className="mr-2" />
          Upload Image
        </Button>
      </div>

      {images.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((image) => (
            <div
              key={image.id}
              className="bg-[#1a1a2e] rounded-xl overflow-hidden border border-gray-800 hover:border-purple-500/50 transition-all group"
            >
              <div className="relative aspect-square">
                <img
                  src={image.url}
                  alt={image.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                  <Button size="icon" className="bg-purple-600 hover:bg-purple-700">
                    <Download size={18} />
                  </Button>
                  <Button
                    size="icon"
                    variant="destructive"
                    onClick={() => handleDelete(image.id)}
                  >
                    <Trash2 size={18} />
                  </Button>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-white font-medium text-sm truncate">{image.name}</h3>
                <p className="text-gray-500 text-xs">{image.createdAt}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-[#1a1a2e] rounded-xl p-12 border border-gray-800 text-center">
          <ImageIcon size={48} className="mx-auto text-gray-600 mb-4" />
          <h3 className="text-white font-semibold mb-2">No images yet</h3>
          <p className="text-gray-400 mb-4">Start generating images or upload your own</p>
          <Button className="bg-purple-600 hover:bg-purple-700 text-white">
            <Upload size={18} className="mr-2" />
            Upload First Image
          </Button>
        </div>
      )}
    </div>
  );
};

export default MyImages;
